<template>
 <div class="crm-container">
    <mcw-layout-grid>
      <mcw-layout-cell desktop="12" tablet="8" phone="4">
        <mcw-button @click="showModal = true" class="btn-primary">
          Создать новый запрос
        </mcw-button>
        <CreateRequestModal
          :show="showModal"
          :organizations="companiesList"
          @close="showModal = false"
          @submit="handleCreateRequest"
        />
      </mcw-layout-cell>
    </mcw-layout-grid>

    <mcw-layout-grid class="requests-grid" v-if="requests.length">
      <!-- Карточки запросов -->
      <mcw-layout-cell
        v-for="request in requests"
        :key="request.id"
        desktop="4"
        tablet="4"
        phone="4"
      >
        <mcw-card class="request-card">
          <h3 class="card-title">{{ request.title }}</h3>
          <p class="card-subtitle">{{ request.org_name || 'ИНКОГНИТО' }}</p>

            <div class="request-meta">
              <div class="status-chip" :class="getStatusClass(request.status)">
                {{ request.status_name }}
              </div>
              <div class="date">{{ request.date_add }}</div>
            </div>

            <p class="request-text">{{ request.text || 'Нет описания' }}</p>

            <!-- Сообщения -->
            <div class="messages-section">
              <div class="messages-title">
                <span>Сообщения:</span>
                <chat-dialog
                  :title="request.title"
                  :subtitle="request.org_name"
                  :messages="request.messages"
                  :id="request.id"
                  @send-message="handleNewMessage"
                />
              </div>
              <section v-if="request.messages?.length">
                <div
                  v-if="request.messages.length > 3"
                  class="message"
                  style="text-align: center;"
                ><mcw-material-icon icon="more_horiz" /></div>
                <div
                  v-for="(message, index) in request.messages.slice(-3)"
                  :key="index"
                  class="message"
                >
                  <div class="message-text">{{ message.text }}</div>
                  <div class="message-meta">
                    {{ formatDate(message.date) }} ({{ message.login }})
                  </div>
                </div>
              </section>
            </div>

            <!-- Менеджер -->
            <section class="manager-section">
              <mcw-select
                :value="request.assignedManager"
                @update:modelValue="onManagerChanged"
                label="Менеджер"
                outlined
                dense
                class="manager-select"
              >
                <mcw-list-item
                  v-for="manager of managers"
                  :key="manager"
                  :data-value="manager.label"
                  role="option"
                  >{{ manager.label }}</mcw-list-item>
              </mcw-select>
            </section>

          <mcw-card-actions class="card-actions">
            <mcw-button @click="editRequest(request)" outlined>
              <mcw-material-icon icon="edit" class="primary-btn" />
            </mcw-button>
            <mcw-button @click="deleteRequest(request.id)" class="delete-btn">
              <mcw-material-icon icon="delete" class="delete-btn" />
            </mcw-button>
          </mcw-card-actions>
        </mcw-card>
      </mcw-layout-cell>
    </mcw-layout-grid>

    <!-- Диалог редактирования -->
    <mcw-dialog
      v-if="editingRequest"
      v-model="editDialog.open"
      :title="`Редактирование: ${editingRequest?.title}`"
    >
      <section>
        <mcw-textfield
          v-model="editingRequest.title"
          label="Тема"
          outlined
          required
        />
        <mcw-textfield
          v-model="editingRequest.org_name"
          label="Заказчик"
          outlined
          required
        />
        <mcw-textfield
          v-model="editingRequest.text"
          label="Описание"
          multiline
          outlined
          rows="3"
        />
        <mcw-select
          v-model="editingRequest.status"
          label="Статус"
          :options="statusOptions"
          outlined
        />
        <mcw-textfield
          v-if="editingRequest.status === 3"
          v-model="editingRequest.status_reason"
          label="Причина"
          outlined
        />
      </section>
      <mcw-dialog-footer>
        <mcw-button @click="editDialog.open = false">Отмена</mcw-button>
        <mcw-button @click="saveEdit" unelevated>Сохранить</mcw-button>
      </mcw-dialog-footer>
    </mcw-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import ChatDialog from './ChatDialog.vue';
import CreateRequestModal from './CreateRequestModal.vue';

export default {
  name: 'Requests',
  components: { ChatDialog, CreateRequestModal },
  data() {
    return {
      requests: [],
      showModal: false,
      newRequest: {
        org_name: '',
        title: '',
        text: '',
        date_add: new Date().toISOString().slice(0, 16),
      },
      editDialog: {
        open: false,
      },
      editingRequest: null,
      managers: [
        { value: 1, label: 'Иванов И.И.' },
        { value: 2, label: 'Петров П.П.' },
        { value: 3, label: 'Сидорова С.С.' },
      ],
      statusOptions: [
        { value: 1, label: 'Новый' },
        { value: 2, label: 'В работе' },
        { value: 3, label: 'Отклонен' },
        { value: 4, label: 'Завершен' },
      ],
    };
  },

  computed: {
    isFormValid() {
      return this.newRequest.org_name
        && this.newRequest.title
        && this.newRequest.date_add;
    },
    ...mapState({
      companiesList: (state) => state.user.companiesList,
    }),
  },
  async mounted() {
    this.fetchRequests();
    await this.$store.dispatch('orgsData/getOrgRequestsStatus');
  },

  methods: {
    async fetchRequests() {
      try {
        const data = await this.$store.dispatch('orgsData/getOrgRequests');
        this.requests = data.map((req) => ({
          ...req,
          messages: req.messages ? JSON.parse(req.messages) : [],
          assignedManager: req.manager ?? 'YAY',
        }));
      } catch (error) {
        console.error('Ошибка загрузки запросов:', error);
      }
    },

    onManagerChanged(manager) {
      console.log(manager);
    },
    createRequest() {
      const newId = Math.max(0, ...this.requests.map((r) => r.id)) + 1;

      this.requests.unshift({
        id: newId,
        org_name: this.newRequest.org_name,
        title: this.newRequest.title,
        text: this.newRequest.text,
        date_add: this.newRequest.date_add,
        status: 1,
        status_name: 'Новый',
        status_reason: null,
        org_inn: null,
        id_org: null,
        login_add: null,
        messages: [],
        timer: null,
        assignedManager: null,
      });

      // Сброс формы
      this.newRequest.org_name = '';
      this.newRequest.title = '';
      this.newRequest.text = '';
      this.newRequest.date_add = new Date().toISOString().slice(0, 16);
    },

    editRequest(request) {
      this.editingRequest = request;
      this.editDialog.open = true;
    },

    async handleNewMessage(message, id) {
      const res = await this.$store.dispatch('orgsData/postOrgsRequestsMessage', { message, id });
      this.requests = res.map((req) => ({
        ...req,
        messages: req.messages ? JSON.parse(req.messages) : [],
        assignedManager: req.manager ?? 'YAY',
      }));
    },

    async handleCreateRequest(requestData) {
      const clearParams = Object.fromEntries(
        Object.entries(requestData).filter(([_, value]) => value !== null),
      );
      console.log(clearParams);
      const res = await this.$store.dispatch('orgsData/postOrgsRequests', clearParams);
      this.requests = res.map((req) => ({
        ...req,
        messages: req.messages ? JSON.parse(req.messages) : [],
        assignedManager: req.manager ?? 'YAY',
      }));
    },

    saveEdit() {
      const index = this.requests.findIndex((r) => r.id === this.editingRequest.id);
      if (index !== -1) {
        const statusName = this.statusOptions.find(
          (s) => s.value === this.editingRequest.status,
        )?.label || this.editingRequest.status_name;

        this.requests[index] = {
          ...this.requests[index],
          ...this.editingRequest,
          date_add: this.requests[index].date_add,
          status_name: statusName,
        };
      }
      this.editDialog.open = false;
    },

    deleteRequest(id) {
      // if (confirm('Удалить запрос?')) {
      //   this.requests = this.requests.filter((r) => r.id !== id);
      // }
      console.log('DELETE?', id);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString('ru-RU');
    },

    getStatusClass(status) {
      const classes = {
        1: 'status-new',
        2: 'status-inwork',
        3: 'status-rejected',
        4: 'status-completed',
      };
      return classes[status] || '';
    },
  },
};
</script>

<style>
.mdc-select .mdc-select__anchor {
  height: 30px !important;
}
</style>

<style scoped>
.crm-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.create-form {
  margin-bottom: 30px;
}

.requests-grid {
  margin-top: 20px;
}

.request-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.375rem;
  padding: 0.5rem;
}

.card-title {
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.2;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: #6c757d;
}

.card-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
}

.request-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.status-chip {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.status-new {
  background-color: #e3f2fd;
  color: #1565c0;
}

.status-inwork {
  background-color: #fff3e0;
  color: #ef6c00;
}

.status-rejected {
  background-color: #ffebee;
  color: #c62828;
}

.status-completed {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.date {
  font-size: 12px;
  color: #757575;
}

.request-text {
  margin: 12px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #424242;
}

.messages-section {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid #e0e0e0;
}

.messages-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 14px;
}

.message {
  margin-bottom: 8px;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.message-text {
  font-size: 13px;
}

.message-meta {
  font-size: 11px;
  color: #757575;
  margin-top: 4px;
}

.manager-select {
  margin-top: 0.75rem;
  width: 100%;
}

.mdc-select {
  width: 100%;
}

.manager-section {
  border-top: 1px solid #e0e0e0;
  margin: 4px 0 0 0;
  padding: 12px 0 0 0;
}

.delete-btn {
  color: #f44336;
}

.primary-btn {
  color: #337ab7;
}

.mcw-textarea {
  width: 100%;
}

.mcw-select {
  width: 100%;
}
</style>
